import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ButtonToolbar, Tooltip } from "react-bootstrap";
import { FormattedDate, FormattedMessage, FormattedTime } from "react-intl";

import { EditButton, OverlayRenderer } from "../../../common";
import { DataTable } from "../../../common/DataTable";
import BasicMessageFields from "./BasicMessageFields";
import MessageStatusToggler from "./MessageStatusToggler";

import { MESSAGES } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";

class MessagesDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.createMessage = this.createMessage.bind(this);
    this.getData = this.getData.bind(this);
    this.markAsRead = this.markAsRead.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(MESSAGES);
  }

  createMessage(values) {
    this.props.dataActions
      .createDataItem(MESSAGES, {
        ...values,
        createdByUserId: this.props.auth.user.userId,
      })
      .then(() => {
        this.props.dataActions.getDataCount(MESSAGES);
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters
        );
      });
  }

  updateMessage(values) {
    this.props.dataActions.updateDataItem(MESSAGES, values).then(() => {
      this.getData(
        this.props.offset,
        this.props.limit,
        this.props.q,
        this.props.sortBy,
        this.props.filters
      );
    });
  }

  getCols() {
    return [
      {
        name: "",
        display: (message) => {
          const { offset, limit, q, sortBy, filters } = this.props;
          return (
            <MessageStatusToggler
              message={message}
              afterToggle={this.getData.bind(
                this,
                offset,
                limit,
                q,
                sortBy,
                filters
              )}
            />
          );
        },
        widthPct: 5,
      },
      {
        name: <FormattedMessage id="messages.datatable.columns.date" />,
        key: "createdAt",
        display: (message) => {
          return (
            <span className="highlighted-datetime">
              <span className="date">
                <FormattedDate
                  value={message.createdAt}
                  year="numeric"
                  month="long"
                  day="2-digit"
                />
              </span>
              <span className="time">
                <FormattedTime
                  value={message.createdAt}
                  hour="numeric"
                  minute="numeric"
                />
              </span>
            </span>
          );
        },
        widthPct: 14,
      },
      {
        name: <FormattedMessage id="messages.datatable.columns.createdBy" />,
        sortKeys: ["createdByUser.firstName", "createdByUser.lastName"],
        display: (message) => (
          <span>{`${message.createdByUser.firstName} ${message.createdByUser.lastName}`}</span>
        ),
        widthPct: 14,
      },
      {
        name: <FormattedMessage id="messages.datatable.columns.message" />,
        key: "message",
        display: (message) => {
          const tooltip = (
            <Tooltip id={message.messageId} className="line-break-tooltip">
              {message.message}
            </Tooltip>
          );
          return (
            <OverlayRenderer
              placement="left"
              overlay={tooltip}
              overlayedClassName="tooltipped-cell"
              forceOverlay={/\r|\n/.test(message.message)}
            >
              <span>{message.message}</span>
            </OverlayRenderer>
          );
        },
        widthPct: 57,
      },
      {
        name: <FormattedMessage id="datatable.actions" />,
        display: (client) => this.generateActionButtons(client),
        widthPct: 9.99,
      },
    ];
  }
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }
  generateActionButtons(message) {
    return (
      <ButtonToolbar key={message.messageId}>
        <EditButton
          title={
            message.createdByUserId == this.props.auth.user.userId ? (
              <FormattedMessage id="messages.datatable.actions.edit" />
            ) : (
              <FormattedMessage id="messages.datatable.actions.view" />
            )
          }
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          label={
            message.createdByUserId == this.props.auth.user.userId ? (
              <FormattedMessage id="common.edit" />
            ) : (
              <FormattedMessage id="common.view" />
            )
          }
          form={BasicMessageFields}
          data={{
            ...message,
            disabled: message.createdByUserId != this.props.auth.user.userId,
          }}
          allowSubmission={
            message.createdByUserId == this.props.auth.user.userId
          }
          editFunction={this.updateMessage}
          onModalClosed={this.markAsRead.bind(
            this,
            message.messageId,
            message.unread
          )}
        />
      </ButtonToolbar>
    );
  }

  generateAddButton() {
    return (
      <div>
        <EditButton
          title={<FormattedMessage id="messages.datatable.actions.add" />}
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          label={<FormattedMessage id="common.add" />}
          add={true}
          form={BasicMessageFields}
          data={{ message: "" }}
          editFunction={this.createMessage}
        />
      </div>
    );
  }

  getData(offset, limit, q, sortBy, filters) {
    const fields = "*";
    const userId = this.props.auth.user.userId;
    return this.props.dataActions
      .getDataList(MESSAGES, offset, limit, q, sortBy, filters, {}, {}, fields)
      .then(() => {
        this.props.dataActions.getDataCount(MESSAGES, [
          `messagesUnread.userId==${userId}`,
        ]);
      });
  }

  markAsRead(messageId, unread) {
    if (!unread) {
      return;
    }
    const model = { path: `/v1/messages/${messageId}/read` };

    return this.props.dataActions.simplePost({ model }).then(() => {
      this.getData(
        this.props.offset,
        this.props.limit,
        this.props.q,
        this.props.sortBy,
        this.props.filters
      );
    });
  }

  render() {
    return (
      <div>
        <DataTable
          ref="dataTable"
          title={<FormattedMessage id="messages.title" />}
          getData={this.getData}
          cols={this.getCols()}
          offset={this.props.offset}
          q={this.props.q}
          filters={this.props.filters}
          data={this.props.messages}
          rowsPerPage={this.props.limit}
          rowHeight={56}
          totalRows={this.props.total}
          showOverflow={false}
          sortBy={this.props.sortBy}
          addButton={this.generateAddButton()}
        />
      </div>
    );
  }
}

MessagesDataTable.propTypes = {
  auth: PropTypes.object,
  dataActions: PropTypes.object,
  q: PropTypes.string,
  filters: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  messages: PropTypes.array,
};

function mapStateToProps(state) {
  const data = state.data.messages || {};
  const pagination = data.pagination || {};
  return {
    auth: state.auth || {},
    limit: pagination.limit || 100,
    q: data.q,
    filters: data.filters || [MESSAGES.archiveFilter],
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["createdAt:desc"],
    total: pagination.totalCount || 0,
    messages: data.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/messages/MessagesDataTable.js